import React, { useContext, useState } from "react";
import "./style.scss";
import { useNavigate, useParams } from "react-router-dom";
import {
  useCompleteDraftSkuOnSegregation,
  useGetSkuDetail,
  useUpdateProcessFilesOnSku,
} from "../../../hooks/useSeggregation";
import { useGetAllMergedGuidelines } from "../../../hooks/useGuidelines";
import { Empty, message, Tag, Tooltip } from "antd";
import Button from "../../../common/Button";
import nextIcon from "../../../assets/AddSubCategory/nextIcon.svg";
import arrowIcon from "../../../assets/SkuList/arrowIcon.svg";
import checkIcon from "../../../assets/AddOnServices/check-circle.svg";
import { useUpsertAddOnServiceToSku } from "../../../hooks/useOrderBatches";
import commentIcon from "../../../assets/SkuList/comment-icon.svg";
import { SeggreagtionContext } from "../../../context/seggregationProvider";
import Stepper from "../../Stepper";

const SelectAddOn = () => {
  const {
    segg_selectedCategory,
    segg_selectedSubCategory,
    segg_selectedMarketplace,
    segg_queryParams,
  } = useContext(SeggreagtionContext);
  const [skuFiles, setSkuFiles] = useState([]);
  const [skuDetails, setSkuDetails] = useState();
  const [droppedImages, setDroppedImages] = useState([]);
  const [selectedInputs, setSelectedInputs] = useState([]);
  const [activeActions, setActiveActions] = useState({});
  const navigate = useNavigate();
  const params = useParams();
  const onSuccessGetSkuDetails = (res) => {
    if (res.status === 200) {
      setSkuFiles(res?.data?.skuFiles);
      setSkuDetails(res?.data?.draftSku);
    }
  };
  const onErrorGetSkuDetails = (err) => {
    console.log(err);
  };
  const { data, refetch: getSkuDetails } = useGetSkuDetail(
    "getSKudetails",
    params?.skuId,
    onSuccessGetSkuDetails,
    onErrorGetSkuDetails
  );
  const onSuccessCompleteDraftSkuOnSegregation = (res) => {
    if (res.status === 200) {
      message.success("Sku Completed");
      navigate(`/seggregation-batch-loading/${segg_queryParams}`);
    }
  };

  const onErrorCompleteDraftSkuOnSegregation = (err) => {
    console.log(err);
  };
  const { mutate: completeDraftSkuOnSegregation } =
    useCompleteDraftSkuOnSegregation(
      onSuccessCompleteDraftSkuOnSegregation,
      onErrorCompleteDraftSkuOnSegregation
    );
  const handleComplete = () => {
    completeDraftSkuOnSegregation(params?.skuId);
  };
  const toggleAction = (actionIndex) => {
    setActiveActions((prevState) => ({
      ...prevState,
      [`${actionIndex}`]: !prevState[`${actionIndex}`],
    }));
  };
  const onSuccessUpsertAddOnServiceToSku = (res) => {
    if (res.status === 200) {
      message.success("Add-On Updated");
      getSkuDetails();
    }
  };

  const onErrorUpsertAddOnServiceToSku = (err) => {
    message.error(err);
  };

  const { mutate: upsertAddOnServiceToSku } = useUpsertAddOnServiceToSku(
    onSuccessUpsertAddOnServiceToSku,
    onErrorUpsertAddOnServiceToSku
  );
  const updateAddOn = (e, serviceId, packageId, variantId, comment) => {
    e.preventDefault();
    let payload = {
      draftSkuId: params?.skuId,
      serviceId: serviceId,
      packageId: packageId,
      variantId: variantId,
      comments: [comment],
    };
    upsertAddOnServiceToSku(payload);
  };
  const handleAddOnComment = (e, addOnId) => {
    const updatedData = skuDetails?.addOnServices.map((addOn) => {
      if (addOn?._id === addOnId) {
        return {
          ...addOn,
          serviceObj: {
            ...addOn.serviceObj,
            items: addOn.serviceObj.items.map((item) => {
              if (item.packageId === addOn.package) {
                return {
                  ...item,
                  variants: item.variants.map((variant) => {
                    if (variant?._id === addOn.variant) {
                      return { ...variant, comment: e.target.value };
                    }
                    return variant;
                  }),
                };
              }
              return item;
            }),
          },
        };
      }
      return addOn;
    });
    setSkuDetails((prevState) => ({
      ...prevState,
      addOnServices: updatedData,
    }));
  };
  const handlePackageChange = (e, addOnId) => {
    const updatedData = skuDetails?.addOnServices.map((addOn) =>
      addOn?._id === addOnId
        ? {
            ...addOn,
            package: e.target.value,
          }
        : addOn
    );
    setSkuDetails((prev) => ({
      ...prev,
      addOnServices: updatedData,
    }));
  };
  return (
    <div className="select_add_on_main_wrapper">
      <div className="select_add_on_header">
        <div className="left_wrapper">
          <div className="content_wrapper">
            <div className="title">Category</div>
            <div className="title_value">{segg_selectedCategory?.name}</div>
          </div>
          <div className="content_wrapper">
            <div className="title">Sub Category</div>
            <div className="title_value">{segg_selectedSubCategory?.name}</div>
          </div>
        </div>
        <div className="right_wrapper">
          <div className="content_wrapper">
            <div className="title">Marketplace</div>
            <div className="market_place_wrapper">
              {skuDetails?.toProcessFilesDraft?.length > 0 &&
                skuDetails?.toProcessFilesDraft?.map((marketplace, index) => {
                  return (
                    <>
                      <div
                        className={`marketplace_title ${
                          marketplace?.isCompleted ||
                          segg_selectedMarketplace?.id ===
                            marketplace?.marketplace?._id
                            ? "active_marketplace"
                            : ""
                        }`}
                        key={`marketplace${index}`}
                      >
                        {marketplace?.marketplace?.name}
                      </div>
                      {skuDetails?.toProcessFilesDraft?.length - 1 !==
                        index && <div className="continue_line" />}
                    </>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="select_add_on_content_wrapper">
        <div className="sku_wrapper">
          <div className="sku_list_container">
            <div className="sku_items_wrapper">
              <div className="sku_header">
                <div className="sku_left_details">
                  <div className="sku_details">
                    <h2 className="sku_title">
                      {skuDetails?.displayName}
                      <span className="count_of_images">
                        {skuDetails?.files?.length} Images
                      </span>
                    </h2>
                  </div>
                </div>
                <div className="sku_add_on_header_wrapper">
                  <div className="text">Add-On Services</div>
                </div>
              </div>

              <div className="sku_items_container">
                <div className="sku_items">
                  {skuFiles?.map((files, id) => {
                    return (
                      <div className="item" key={`toProcess${id}`}>
                        <div className="image">
                          <img src={files?.image?.thumbPath.url} alt="" />
                        </div>
                        <Tooltip
                          title={files?.image?.name}
                          placement="rightTop"
                        >
                          <span>{`${files?.image?.name.slice(0, 15)}...`}</span>
                        </Tooltip>
                      </div>
                    );
                  })}
                </div>
                <div className="add_on_list_container">
                  {skuDetails?.addOnServices?.map((addOn, addOnIndex) => {
                    return (
                      <div
                        className="add_on_content"
                        key={`addOnIndex${addOnIndex}`}
                      >
                        <div className="add_on_list_header">
                          <div className="heading_title">
                            {addOn?.serviceName}
                          </div>
                        </div>
                        {addOn.serviceObj.items.length > 1 && (
                          <div className="select_package_wrapper">
                            <select
                              value={addOn.package}
                              onChange={(e) =>
                                handlePackageChange(e, addOn?._id)
                              }
                              className="package_section"
                            >
                              {addOn?.serviceObj.items.map((item) => (
                                <option
                                  key={`service${item?.packageId}`}
                                  value={item?.packageId}
                                >
                                  {item?.packageName}
                                </option>
                              ))}
                            </select>
                            <img src={arrowIcon} alt="arrow" />
                          </div>
                        )}
                        <div className="variant_wrapper">
                          <div className="button_container">
                            {addOn.serviceObj.items
                              .find((item) => item.packageId === addOn.package)
                              ?.variants.map((variant) => {
                                return (
                                  <button
                                    key={variant?._id}
                                    className={`variant_button ${
                                      variant?._id === addOn.variant
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={(e) => {
                                      updateAddOn(
                                        e,
                                        addOn.service,
                                        addOn.package,
                                        variant?._id,
                                        ""
                                      );
                                    }}
                                  >
                                    {variant?.name}
                                  </button>
                                );
                              })}
                          </div>
                          <div className="arrow_wrapper">
                            <img
                              src={arrowIcon}
                              alt="arrow"
                              className={
                                activeActions[`${addOnIndex}`] ? "" : "rotate"
                              }
                              onClick={() => toggleAction(addOnIndex)}
                            />
                          </div>
                        </div>
                        {activeActions[`${addOnIndex}`] && (
                          <>
                            <div className="add_on_details">
                              <div className="features_wrapper">
                                <div className="feature_heading">Includes </div>
                                <ul>
                                  {addOn.serviceObj.items
                                    .find(
                                      (item) => item.packageId === addOn.package
                                    )
                                    ?.variants.find(
                                      (variant) =>
                                        variant?._id === addOn.variant
                                    )
                                    ?.features.map((variantData) => {
                                      return (
                                        <li>
                                          <div className="icon_wrapper">
                                            <img
                                              src={checkIcon}
                                              alt="checkIcon"
                                            />
                                          </div>
                                          {variantData}
                                        </li>
                                      );
                                    })}
                                </ul>
                              </div>
                              <div className="image_comment_wrapper">
                                <div className="image_container">
                                  <div className="before_image_wrapper">
                                    <div className="heading">Before</div>
                                    <div className="image_wrapper">
                                      {/* <img
                                              src={model1}
                                              alt="before_img"
                                            /> */}
                                    </div>
                                  </div>
                                  <div className="after_image_wrapper">
                                    <div className="heading">After</div>
                                    <div className="image_wrapper">
                                      {/* <img
                                              src={model1}
                                              alt="before_img"
                                            /> */}
                                    </div>
                                  </div>
                                </div>
                                <div className="break" />
                                <div className="comment_wrapper">
                                  <div className="heading">Comments</div>
                                  <textarea
                                    placeholder="Write your comment"
                                    value={
                                      addOn.serviceObj.items
                                        .find(
                                          (item) =>
                                            item.packageId === addOn.package
                                        )
                                        ?.variants.find(
                                          (variant) =>
                                            variant?._id === addOn.variant
                                        )?.comment
                                    }
                                    onChange={(e) =>
                                      handleAddOnComment(e, addOn?._id)
                                    }
                                  />
                                  <button
                                    onClick={(e) =>
                                      updateAddOn(
                                        e,
                                        addOn?.service,
                                        addOn?.package,
                                        addOn?.variant,
                                        addOn.serviceObj.items
                                          .find(
                                            (item) =>
                                              item.packageId === addOn.package
                                          )
                                          ?.variants.find(
                                            (variant) =>
                                              variant?._id === addOn.variant
                                          )?.comment
                                      )
                                    }
                                  >
                                    <img src={commentIcon} alt="" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="add_on_upload_section">
                          {addOn?.actionResult?.length > 0 &&
                            addOn.actionResult.map((actionResult, index) => {
                              return actionResult.imageArray.length > 0 ? (
                                actionResult.imageArray.map((image, id) => {
                                  return (
                                    <div className="action_image_main_container">
                                      <div className="action_result_wrapper">
                                        <img
                                          src={image?.imagePath?.url}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <div className="action_image_main_container">
                                  <div className="action_result_wrapper">
                                    <img
                                      src={actionResult?.image?.imagePath.url}
                                      alt=""
                                    />
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="bottom_panel">
            <Stepper isSeggregation={true} activeStep={3} isSeggAddOn={true} />
            <div className="action_container">
              <Button
                text="Complete"
                width={"140px"}
                height="50px"
                handleClick={() => handleComplete()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SelectAddOn;
